import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../reducer/userReducer";
import modalReducer from "../reducer/modalReducer";
import registrationReducer from "../reducer/registrationReducer";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import tourReducer from "../reducer/tourReducer";
import uiReducer from "../reducer/uiReducer";
import dropdownReducer from "../reducer/dropdownSlice";
import userTypeReducer from "../reducer/userTypeReducer";
import profileReducer from "../reducer/profileReducer";
import companyInformationReducer from "../reducer/companyInformationReducer";
import ContactInformationReducer from "../reducer/contacInformationReducer";
import additionalInformationReducer from "../reducer/additionalInformationReducer";
import insuranceProviderReducer from "../reducer/insuranceProviderReducer";
import sidebarReducer from "../reducer/sideBarSlice";
import { saveState } from "../utils/LocalStorage";
import { initialState } from "../reducer/tourReducer";
import tourEditReducer from "../reducer/tourEditReducer";

export const store = configureStore({
  reducer: {
    account: userReducer,
    ui: uiReducer,
    modal: modalReducer,
    registration: registrationReducer,
    tour: tourReducer,
    dropdown: dropdownReducer,
    userType: userTypeReducer,
    profile: profileReducer,
    Companypending: companyInformationReducer,
    ContanctPending: ContactInformationReducer,
    additionalPending: additionalInformationReducer,
    inuranceProvider: insuranceProviderReducer,
    sidbarActiveTab: sidebarReducer,
    edit: tourEditReducer,
  },
});
store.subscribe(() => {
  const state = store.getState();
  saveState(state.tour);
  localStorage.setItem(
    "prePackagesData",
    JSON.stringify(state.tour.prePackagesData)
  );
  localStorage.setItem("optionsData", JSON.stringify(state.tour.optionsData));
  localStorage.setItem(
    "mealSettingsData",
    JSON.stringify(state.tour.mealSettingsData)
  );
});

store.subscribe(() => {
  const state = store.getState();
  if (state.tour === initialState) {
    // Check if the state is reset
    localStorage.removeItem("tourState");
    localStorage.removeItem("prePackagesData");
    localStorage.removeItem("optionsData");
    localStorage.removeItem("mealSettingsData");
  }
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
